<template>
  <div
    class="desktop-validate-container"
    :class="{ 'ios-device': device === 'ios' }"
  >
    <div class="desk-icon"></div>
    <div class="title">Apphi For Desktop</div>
    <div class="des">Go to desktop.apphi.com to use Apphi on desktop/PC</div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme";

.ios-device {
  padding-bottom: 50px;
}

.desktop-validate-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 0 30px;

  .title {
    font-size: 26px;
    color: #8c8c8c;
    font-weight: 500;
    margin-top: 37px;
  }

  .des {
    font-size: 20px;
    color: #8c8c8c;
    margin-top: 20px;
  }

  .desk-icon {
    width: 30vw;
    height: 30vw;
    background-image: url("../../../public/images/login/empty_pic@3x.png");
    background-size: contain;
  }
}
</style>
<script>
import { getDevice } from "../../utils";

export default {
  name: "DesktopValidatePage",
  data() {
    return {
      device: "",
    };
  },
  created() {
    this.device = getDevice();
  },
};
</script>
